import AsyncStorage from '@react-native-async-storage/async-storage';
import {Picker} from '@react-native-picker/picker';
import axios from 'axios';
import {Formik} from 'formik';
import {DataTable} from 'react-native-paper';
import {globalStyles} from '../../../styles/globalStyles';
import {confirmAlert} from 'react-confirm-alert';
import {FancyAlert} from 'react-native-expo-fancy-alerts';
import React, {
  useEffect,
  useCallback,
  useState,
  useContext,
  createRef,
  useRef,
} from 'react';
import {
  ActivityIndicator,
  Dimensions,
  FlatList,
  ImageBackground,
  KeyboardAvoidingView,
  TouchableWithoutFeedback,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
  Button,
  Image,
  Keyboard,
  Linking,
  SafeAreaView,
  Animated,
  LogBox,
  Pressable,
  Alert,
  Modal,
} from 'react-native';
if (Platform.OS === 'web') {
  require('react-confirm-alert/src/react-confirm-alert.css');
}
import {responsiveWidth} from 'react-native-responsive-dimensions';
import {
  Table,
  TableWrapper,
  Row,
  Rows,
  Col,
  Cols,
  Cell,
} from 'react-native-table-component';
import {BASE_URL} from '../../../components/BaseUrl';
//import ScreenBackground from '../../../components/ScreenBackground';
import AppBtn from '../../../shared/appBtn';
import WavyTopBar from '../../../shared/WavyTopBar';
import InputLevel from '../../../shared/inputLevel';
import LeftBar from '../../../shared/LeftBar';
import LeftBarItem from '../../../shared/LeftBarItem';
import DateTimePickerModal from 'react-native-modal-datetime-picker';
import moment from 'moment';
//import { format } from 'date-fns';
import ErrorText from '../../../shared/errorText';
import DropDownFormik from '../../../shared/DropDownFormik';

import {
  DatePickerModal,
  DatePickerModalContent,
  TimePickerModal,
  DatePickerInput,
  // @ts-ignore TODO: try to fix expo to work with local library
} from 'react-native-paper-dates';
import {Popable} from 'react-native-popable';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import {useFocusEffect, useNavigation} from '@react-navigation/native';
import * as yup from 'yup';
import {
  DefaultThemeColors,
  DarkThemeColors,
  ThemeOne,
  ThemeTwo,
} from '../../../utils/constants/Colors';
import {showAlert, closeAlert} from 'react-native-customisable-alert';
const windowHeight = Dimensions.get('window').height;

const registerSchema = yup.object({
  division_name: yup.string().required('Division is required'),
  district_name: yup.string().required('District is required'),
  lower_court_name: yup.string().required('Lower Court is required'),
});

const Colors2 = ThemeOne;
const windowWidth = Dimensions.get('window').width;
const tableWidth = windowWidth - 220;
export default function DashboardScreen() {
  const navigation = useNavigation();

  const parent = navigation.getParent();

  const onScroll = event => {
    const currentPos = 0;
    const currentOffset = event.nativeEvent.contentOffset.y;
    const dif = currentOffset - currentPos;
    if (currentOffset == 0) {
      parent?.setOptions({tabBarStyle: {display: 'flex', animated: true}});
    }
    if (Math.abs(dif) < 3) {
    } else if (dif < 0) {
      parent?.setOptions({tabBarStyle: {display: 'flex', animated: true}});
    } else {
      parent?.setOptions({
        tabBarStyle: {
          display: 'flex',
          marginTop: -75,
          elevation: 15,
          zIndex: 9999999,
          animated: true,
        },
      });
    }
    currentPos = currentOffset;
  };

  const [refreshing] = useState(true);
  const [endLoader, setEndLoader] = useState(1);
  const onEndReached = () => {
    //console.log('end reached');
    setEndLoader(0);
  };
  const [tableData] = useState([]);
  const [court, setCourt] = useState([]);
  const [lower_court, setLowerCourt] = useState([]);
  const [caseInfo, setCaseInfo] = useState([]);
  const [isSearchDateBig, setIsSearchDateBig] = useState(0);
  const [court_id, setCourtId] = useState(null);
  const [lower_court_id, setLowerCourtId] = useState(null);
  const [caseInfoId, setCaseInfoId] = useState(null);
  //const [lower_court_name, setLowerCourtName] = useState("");
  const [district_name, setDistrictName] = useState('');
  const [isDatePickerVisible, setDatePickerVisibility] = useState(false);
  const [select_date, setselectdate] = useState(null);
  const [user_id, setUserId] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const [lower_courts, setLowerCourts] = useState([]);
  // const inputRef = React.useRef(null);
  const [division, setdivision] = useState([]);
  const [division_id, setdivisionId] = useState(null);
  const [district_id, setDistrictId] = useState(null);
  const [typeOfAalto_id, setTypeOfAaltoId] = useState(null);
  const [dairyName_id, setDairyNameId] = useState(null);
  const [dairyName, setDairyName] = useState(null);
  const [district, setDistrict] = useState([]);
  const [dairyNamelist, setDairyNamelist] = useState([]);
  const [halnagatTime, setHalnagatTime] = useState([]);
  const [dayName, setDayName] = useState([]);
  const [courtType, setCourtType] = useState([]);
  const [isheader, setIsheader] = useState(false);
  const [activeTab, setActiveTab] = useState('images');
  const [imageModalVisible, setImageModalVisible] = useState(false);
  const [grAllData, setGrAllData] = useState([]);
  const [grSingleData, setGrSingleData] = useState(null);
  const typeOfAalto = [
    {
      id: '1',
      name: 'জি আর শাখার আদালত',
      office_origin_ids: [],
      type: '0',
    },
    {
      id: '2',
      name: 'জেলা জজ আদালত',
      office_origin_ids: [
        4, 5, 6, 7, 8, 18, 19, 20, 21, 74, 75, 76, 83, 94, 103, 105,
      ],
      type: '1',
    },
    {
      id: '3',
      name: 'চীফ জুডিসিয়াল ম্যাজিস্ট্রেট আদালত',
      office_origin_ids: [14, 15, 16, 17, 84, 85, 91, 95],
      type: '1',
    },
    {
      id: '4',
      name: 'ট্রাইবুনালসমূহ',
      office_origin_ids: [
        89, 9, 72, 73, 77, 79, 80, 81, 82, 86, 87, 96, 102, 104, 110, 111, 112,
      ],
      type: '1',
    },
  ];
  const typeOfmetrocourt = [
    {
      id: '1',
      name: 'জি আর শাখার আদালত',
      office_origin_ids: [],
      type: '0',
    },
    {
      id: '5',
      name: 'মহানগর দায়রা জজ আদালত',
      office_origin_ids: [10, 11, 12, 88],
      type: '2',
    },
    {
      id: '6',
      name: 'চীফ মেট্রোপলিটন ম্যাজিস্ট্রেট আদালত',
      office_origin_ids: [13, 22, 23, 24, 78, 92, 100],
      type: '2',
    },
    {
      id: '7',
      name: 'বিশেষ ট্রাইব্যুনাল',
      office_origin_ids: [109],
      type: '2',
    },
  ];

  const filterCourtsByOriginId = async (data, itemId, office_origin_ids) => {
    try {
      // GR Branch
      if (Number(itemId) === 1) {
        const gr_court = await _fetchLowerCourtDataforGr();

        setLowerCourts(
          gr_court.map(marker => ({
            ...marker,
            value: marker.id,
            label: marker.name_bng,
          })),
        );

        return;
      }

      // Other Courts
      const officeOriginSet = new Set(office_origin_ids);

      const Alllower_courts = lower_court.filter(item =>
        officeOriginSet.has(item.office_origin_id),
      );

      setLowerCourts(
        Alllower_courts.map(marker => ({
          ...marker,
          value: marker.id,
          label: marker.office_name_bng,
        })),
      );
    } catch (error) {
      console.log('filterCourtsByOriginId Error:', error);
    }
  };

  const showDatePicker = () => {
    setDatePickerVisibility(true);
  };

  const hideDatePicker = () => {
    setDatePickerVisibility(false);
  };

  const handleConfirm = val => {
    // console.warn("A date has been picked: ", date);
    //console.log(val);
    setselectdate(val);
    hideDatePicker();
  };
  const [visible, setVisible] = React.useState(false);
  const onDismiss = React.useCallback(() => {
    setVisible(false);
  }, [setVisible]);
  const [date, setDate] = React.useState(new Date());
  const onChangeSingle = React.useCallback(
    params => {
      setVisible(false);
      setDate(params.date);
    },
    [setVisible, setDate],
  );
  const pastDate = new Date(new Date().setDate(new Date().getDate() - 500000));
  const futureDate = new Date(
    new Date().setDate(new Date().getDate() + 500000),
  );

  const locale = 'en-GB';

  const ListFooterComponent = (
    <View style={styles.listFooter}>
      <ActivityIndicator animating={true} size="large" color="#00ff00" />
    </View>
  );

  const _fetchCourtData = async user_id => {
    try {
      let url = `${BASE_URL}/GetCourtName?user_id=` + user_id;
      let response = await axios.get(url).then(res => res.data);

      return response;
    } catch (err) {
      console.log('Error', err);
    }
  };

  // const _fetchLowerCourtData = async (data) => {
  //   try {let dataToSend = {
  //     id:data,
  //     user_id: user_id,
  //   //  court_name_id:data
  //     };
  //   let formBody = [];
  //   for (let key in dataToSend) {
  //     let encodedKey = encodeURIComponent(key);
  //     let encodedValue = encodeURIComponent(dataToSend[key]);
  //     formBody.push(encodedKey + '=' + encodedValue);
  //   }
  //   formBody = formBody.join('&');
  //     //let url = `${BASE_URL}/CourtNameToLowerCourt`;  //Custom Old
  //     let url = `${BASE_URL}/GetCourtNameToCourtNameNumber`;
  //     let response = await axios.post(url, formBody).then(res => res.data);

  //     return response;
  //   } catch (err) {
  //     console.log('Error', err);
  //   }
  // };

  const _fetchCaseInfoData = async (values, actions) => {
    setCaseInfo([]);
    console.log(values);

    if (Number(typeOfAalto_id) !== 1) {
      try {
        let dataToSend = {
          //user_id: 22,
          user_id: user_id,
          //court_id: court_id,
          //our_lower_court_id: lower_court_id,

          division_id: division_id,
          geo_district_id: district_id,
          lower_court_id: values.lower_court_name,
          //search_date: "2023-03-29",
          search_date:
            Platform.OS === 'web'
              ? date !== null
                ? moment(date).format('YYYY-MM-DD')
                : ''
              : select_date !== null
              ? moment(select_date).format('YYYY-MM-DD')
              : moment().format('YYYY-MM-DD'),
        };
        let formBody = [];
        for (let key in dataToSend) {
          let encodedKey = encodeURIComponent(key);
          let encodedValue = encodeURIComponent(dataToSend[key]);
          formBody.push(encodedKey + '=' + encodedValue);
        }

        //console.log(formBody);

        formBody = formBody.join('&');

        let url = `${BASE_URL}/GetCaseInfoWithPaging`;
        let response = await axios.post(url, formBody).then(res => res.data);
        setIsLoading(false);
        setActiveTab('files');
        //console.log(response);

        //if (response.country) return response.country;

        //Court image loding
        const imgresponse = await axios.get(`${BASE_URL}/GetCourtImages`, {
          params: {
            lower_court_id: values.lower_court_name,
            status: 1,
            cause_date: date
              ? moment(date).format('YYYY-MM-DD')
              : moment(new Date(date)).format('YYYY-MM-DD'),
          },
        });

        // console.log('Search imgresponse:', imgresponse.data);
        if (imgresponse.status == 200) {
          // console.log(imgresponse.data);
          setIsLoading(false);
          setGrAllData(imgresponse.data);
          setActiveTab('images');
        }

        return response;
      } catch (err) {
        console.log('Error', err);
      }
    } else {
      if (!dairyName_id) {
        alert('Please Select Dairy name');
      }
      try {
        const response = await axios.get(`${BASE_URL}/GetThanaImages`, {
          params: {
            diary_police_station_id: dairyName_id,
            status: 1,
            cause_date: date
              ? moment(date).format('YYYY-MM-DD')
              : moment(new Date(date)).format('YYYY-MM-DD'),
          },
        });

        // console.log('Search Response:', response.data);
        if (response.status == 200) {
          console.log(response.data);
          setIsLoading(false);
          setGrAllData(response.data);
        }
        setActiveTab('images');
      } catch (error) {
        console.log('Get All Data Error:', error);
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    }
  };

  useFocusEffect(
    React.useCallback(() => {
      setIsLoading(false);
      setIsSearch(false);
      setCaseInfo([]);
    }, []),
  );

  const groupImagesIntoRows = data => {
    const rows = [];
    for (let i = 0; i < data.length; i += 3) {
      rows.push(data.slice(i, i + 3));
    }
    return rows;
  };
  const handleImageModal = data => {
    setImageModalVisible(true);
    setGrSingleData(data);
  };

  const renderImageRow = (
    {item}, // Pass date as parameter
  ) => (
    <View style={styles.imageRow}>
      {item.map((image, idx) => (
        <View
          key={idx}
          style={{
            width: '33.33%', // Important: Set width on the container
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 20,
          }}
        >
          <TouchableOpacity
            onPress={() => handleImageModal(image)}
            style={{width: '100%', alignItems: 'center'}}
          >
            <Image
              source={{uri: 'https://api.bdjudgecourt.com' + image.file_path}}
              style={{
                width: '100%',
                height: 250,
                resizeMode: 'cover',
              }}
            />
          </TouchableOpacity>

          <Text
            style={{
              fontSize: 16,
              marginTop: 20,
              color: '#555',
              textAlign: 'center',
              lineHeight: 24,
              fontWeight: '500',
            }}
          >
            তারিখ :{' '}
            {date
              ? engToBdNum(moment(date).format('DD-MM-YYYY'))
              : engToBdNum(moment(new Date(date)).format('DD-MM-YYYY'))}
          </Text>
        </View>
      ))}
      {/* Fill empty slots if less than 3 images */}
      {item.length < 3 &&
        [...Array(3 - item.length)].map((_, idx) => (
          <View
            key={`empty-${idx}`}
            style={[styles.imageRowItem, {width: '33.33%'}]}
          />
        ))}
    </View>
  );
  /*
   ReturnCleanASCII =  (stIn) => {
    try {
      const stIn = stIn;
      stIn = stIn.Replace("0", "০");
      stIn = stIn.Replace("1", "১");
      stIn = stIn.Replace("2", "২");
      stIn = stIn.Replace("3", "৩");
      stIn = stIn.Replace("4", "৪");
      stIn = stIn.Replace("5", "৫");
      stIn = stIn.Replace("6", "৬");
      stIn = stIn.Replace("7", "৭");
      stIn = stIn.Replace("8", "৮");
      stIn = stIn.Replace("9", "৯");
      return stIn;
      
    } catch (err) {
      console.log('Error', err);
    }
  }*/

  //ReplaceTextFunction=(stIn)=>{
  function ReplaceTextFunction(stIn) {
    var SampleText = stIn;
    var stIn = SampleText.replace('2023', '২০২৩');
    stIn = stIn.replace('2024', '২০২৪');
    stIn = stIn.replace('2025', '২০২৫');
    stIn = stIn.replace('2026', '২০২৬');
    stIn = stIn.replace('2027', '২০২৭');
    stIn = stIn.replace('2028', '২০২৮');
    stIn = stIn.replace('2029', '২০২৯');
    stIn = stIn.replace('2030', '২০৩০');
    stIn = stIn.replace('00', '০০');
    stIn = stIn.replace('01', '০১');
    stIn = stIn.replace('01', '০১');
    stIn = stIn.replace('02', '০২');
    stIn = stIn.replace('02', '০২');
    stIn = stIn.replace('03', '০৩');
    stIn = stIn.replace('03', '০৩');
    stIn = stIn.replace('04', '০৪');
    stIn = stIn.replace('04', '০৪');
    stIn = stIn.replace('05', '০৫');
    stIn = stIn.replace('05', '০৫');
    stIn = stIn.replace('06', '০৬');
    stIn = stIn.replace('06', '০৬');
    stIn = stIn.replace('07', '০৭');
    stIn = stIn.replace('07', '০৭');
    stIn = stIn.replace('08', '০৮');
    stIn = stIn.replace('08', '০৮');
    stIn = stIn.replace('09', '০৯');
    stIn = stIn.replace('09', '০৯');
    stIn = stIn.replace('10', '১০');
    stIn = stIn.replace('10', '১০');
    stIn = stIn.replace('11', '১১');
    stIn = stIn.replace('11', '১১');
    stIn = stIn.replace('12', '১২');
    stIn = stIn.replace('12', '১২');
    stIn = stIn.replace('13', '১৩');
    stIn = stIn.replace('14', '১৪');
    stIn = stIn.replace('15', '১৫');
    stIn = stIn.replace('16', '১৬');
    stIn = stIn.replace('17', '১৭');
    stIn = stIn.replace('18', '১৮');
    stIn = stIn.replace('19', '১৯');
    stIn = stIn.replace('20', '২০');
    stIn = stIn.replace('21', '২১');
    stIn = stIn.replace('22', '২২');
    stIn = stIn.replace('23', '২৩');
    stIn = stIn.replace('24', '২৪');
    stIn = stIn.replace('25', '২৫');
    stIn = stIn.replace('26', '২৬');
    stIn = stIn.replace('27', '২৭');
    stIn = stIn.replace('28', '২৮');
    stIn = stIn.replace('29', '২৯');
    stIn = stIn.replace('30', '৩০');
    stIn = stIn.replace('31', '৩১');
    stIn = stIn.replace('32', '৩২');
    stIn = stIn.replace('33', '৩৩');
    stIn = stIn.replace('34', '৩৪');
    stIn = stIn.replace('35', '৩৫');
    stIn = stIn.replace('36', '৩৬');
    stIn = stIn.replace('37', '৩৭');
    stIn = stIn.replace('38', '৩৮');
    stIn = stIn.replace('39', '৩৯');
    stIn = stIn.replace('40', '৪০');
    stIn = stIn.replace('41', '৪১');
    stIn = stIn.replace('42', '৪২');
    stIn = stIn.replace('43', '৪৩');
    stIn = stIn.replace('44', '৪৪');
    stIn = stIn.replace('45', '৪৫');
    stIn = stIn.replace('46', '৪৬');
    stIn = stIn.replace('47', '৪৭');
    stIn = stIn.replace('48', '৪৮');
    stIn = stIn.replace('49', '৪৯');
    stIn = stIn.replace('50', '৫০');
    stIn = stIn.replace('51', '৫১');
    stIn = stIn.replace('52', '৫২');
    stIn = stIn.replace('53', '৫৩');
    stIn = stIn.replace('54', '৫৪');
    stIn = stIn.replace('55', '৫৫');
    stIn = stIn.replace('56', '৫৬');
    stIn = stIn.replace('57', '৫৭');
    stIn = stIn.replace('58', '৫৮');
    stIn = stIn.replace('59', '৫৯');
    stIn = stIn.replace('PM', 'পি এম');
    stIn = stIn.replace('AM', 'এ এম');
    stIn = stIn.replace('0', '০');
    // console.log(stIn);
    return stIn;
  }

  function ReplaceTextDayFunction(stIn) {
    var SampleText = stIn;
    var stIn = SampleText.replace('Saturday', 'শনিবার');
    stIn = stIn.replace('Sunday', 'রবিবার');
    stIn = stIn.replace('Monday', 'সোমবার');
    stIn = stIn.replace('Tuesday', 'মঙ্গলবার');
    stIn = stIn.replace('Wednesday', 'বুধবার');
    stIn = stIn.replace('Thursday', 'বৃহস্পতিবার');
    stIn = stIn.replace('Friday', 'শুক্রবার');
    //console.log(stIn);
    return stIn;
  }

  function ReplaceTextFunctionNumber(stIn) {
    var SampleText = stIn;
    var stIn = SampleText.replace('00', '০০');
    stIn = stIn.replace('01', '০১');
    stIn = stIn.replace('01', '০১');
    stIn = stIn.replace('02', '০২');
    stIn = stIn.replace('02', '০২');
    stIn = stIn.replace('03', '০৩');
    stIn = stIn.replace('03', '০৩');
    stIn = stIn.replace('04', '০৪');
    stIn = stIn.replace('04', '০৪');
    stIn = stIn.replace('05', '০৫');
    stIn = stIn.replace('05', '০৫');
    stIn = stIn.replace('06', '০৬');
    stIn = stIn.replace('06', '০৬');
    stIn = stIn.replace('07', '০৭');
    stIn = stIn.replace('07', '০৭');
    stIn = stIn.replace('08', '০৮');
    stIn = stIn.replace('08', '০৮');
    stIn = stIn.replace('09', '০৯');
    stIn = stIn.replace('09', '০৯');
    stIn = stIn.replace('10', '১০');
    stIn = stIn.replace('10', '১০');
    stIn = stIn.replace('11', '১১');
    stIn = stIn.replace('11', '১১');
    stIn = stIn.replace('12', '১২');
    stIn = stIn.replace('12', '১২');
    stIn = stIn.replace('13', '১৩');
    stIn = stIn.replace('14', '১৪');
    stIn = stIn.replace('15', '১৫');
    stIn = stIn.replace('16', '১৬');
    stIn = stIn.replace('17', '১৭');
    stIn = stIn.replace('18', '১৮');
    stIn = stIn.replace('19', '১৯');
    stIn = stIn.replace('20', '২০');
    stIn = stIn.replace('21', '২১');
    stIn = stIn.replace('22', '২২');
    stIn = stIn.replace('23', '২৩');
    stIn = stIn.replace('24', '২৪');
    stIn = stIn.replace('25', '২৫');
    stIn = stIn.replace('26', '২৬');
    stIn = stIn.replace('27', '২৭');
    stIn = stIn.replace('28', '২৮');
    stIn = stIn.replace('29', '২৯');
    stIn = stIn.replace('30', '৩০');
    stIn = stIn.replace('31', '৩১');
    stIn = stIn.replace('32', '৩২');
    stIn = stIn.replace('33', '৩৩');
    stIn = stIn.replace('34', '৩৪');
    stIn = stIn.replace('35', '৩৫');
    stIn = stIn.replace('36', '৩৬');
    stIn = stIn.replace('37', '৩৭');
    stIn = stIn.replace('38', '৩৮');
    stIn = stIn.replace('39', '৩৯');
    stIn = stIn.replace('40', '৪০');
    stIn = stIn.replace('41', '৪১');
    stIn = stIn.replace('42', '৪২');
    stIn = stIn.replace('43', '৪৩');
    stIn = stIn.replace('44', '৪৪');
    stIn = stIn.replace('45', '৪৫');
    stIn = stIn.replace('46', '৪৬');
    stIn = stIn.replace('47', '৪৭');
    stIn = stIn.replace('48', '৪৮');
    stIn = stIn.replace('49', '৪৯');
    stIn = stIn.replace('50', '৫০');
    stIn = stIn.replace('51', '৫১');
    stIn = stIn.replace('52', '৫২');
    stIn = stIn.replace('53', '৫৩');
    stIn = stIn.replace('54', '৫৪');
    stIn = stIn.replace('55', '৫৫');
    stIn = stIn.replace('56', '৫৬');
    stIn = stIn.replace('57', '৫৭');
    stIn = stIn.replace('58', '৫৮');
    stIn = stIn.replace('60', '৬০');
    stIn = stIn.replace('61', '৬১');
    stIn = stIn.replace('62', '৬২');
    stIn = stIn.replace('63', '৬৩');
    stIn = stIn.replace('64', '৬৪');
    stIn = stIn.replace('65', '৬৫');
    stIn = stIn.replace('66', '৬৬');
    stIn = stIn.replace('67', '৬৭');
    stIn = stIn.replace('68', '৬৮');
    stIn = stIn.replace('69', '৬৯');
    stIn = stIn.replace('70', '৭০');
    stIn = stIn.replace('71', '৭১');
    stIn = stIn.replace('72', '৭২');
    stIn = stIn.replace('73', '৭৩');
    stIn = stIn.replace('74', '৭৪');
    stIn = stIn.replace('75', '৭৫');
    stIn = stIn.replace('76', '৭৬');
    stIn = stIn.replace('77', '৭৭');
    stIn = stIn.replace('78', '৭৮');
    stIn = stIn.replace('79', '৭৯');
    stIn = stIn.replace('80', '৮০');
    stIn = stIn.replace('81', '৮১');
    stIn = stIn.replace('82', '৮২');
    stIn = stIn.replace('83', '৮৩');
    stIn = stIn.replace('84', '৮৪');
    stIn = stIn.replace('85', '৮৫');
    stIn = stIn.replace('86', '৮৬');
    stIn = stIn.replace('87', '৮৭');
    stIn = stIn.replace('88', '৮৮');
    stIn = stIn.replace('89', '৮৯');
    stIn = stIn.replace('90', '৯০');
    stIn = stIn.replace('91', '৯১');
    stIn = stIn.replace('92', '৯২');
    stIn = stIn.replace('93', '৯৩');
    stIn = stIn.replace('94', '৯৪');
    stIn = stIn.replace('95', '৯৫');
    stIn = stIn.replace('96', '৯৬');
    stIn = stIn.replace('97', '৯৭');
    stIn = stIn.replace('98', '৯৮');
    stIn = stIn.replace('99', '৯৯');
    stIn = stIn.replace('100', '১০০');
    stIn = stIn.replace('0', '০');
    // console.log(stIn);
    return stIn;
  }
  const banglaNumber = {
    0: '০',
    1: '১',
    2: '২',
    3: '৩',
    4: '৪',
    5: '৫',
    6: '৬',
    7: '৭',
    8: '৮',
    9: '৯',
  };
  const engToBdNum = str => {
    for (var x in banglaNumber) {
      str = str.replace(new RegExp(x, 'g'), banglaNumber[x]);
    }
    return str;
  };
  const closeDropdown = useCallback(() => {
    setLowerCourtOpen(false);
    // setCaseTypeOpen(false)
  }, []);
  const isPlaceholder = value => {
    return value == null;
  };

  useEffect(() => {
    window.history.pushState(null, null, document.URL);
    //async fetch user data
    getUserId().then(UserId => {
      setUserId(UserId);
      _fetchCourtData(UserId)
        .then(court => {
          setCourt(court);
        })
        .catch(err => console.log(err));

      _fetchdivisionData()
        // eslint-disable-next-line no-shadow
        .then(division => {
          //console.log(division);
          setdivision(division);
        })
        .catch(err => console.log(err));
    });

    /*
      halnagatDateTime()
      .then(halnagat => {
          setHalnagatTime(ReplaceTextFunction(halnagat[0].halnagatTime));
          setDayName(ReplaceTextDayFunction(halnagat[0].day_name));
      })
      .catch(err => console.log(err));
      */

    // if (inputRef?.current) {
    //   inputRef?.current?.setNativeProps({
    //     type: 'date',
    //     min: '1920-01-01',
    //     max: '2120-01-01',
    //     pattern: 'd{4}-d{2}-d{2}',
    //   })
    // }
    LogBox.ignoreLogs([
      'VirtualizedLists should never be nested inside plain ScrollViews with the same orientation because it can break windowing and other functionality - use another VirtualizedList-backed container instead.',
    ]);
  }, []);

  const halnagatDateTime = async () => {
    try {
      //let url = `${BASE_URL}/GetHalnagatTime`;
      //let response = await axios.get(url).then(res => res.data);

      let dataToSend = {
        division_id: division_id,
        search_date:
          Platform.OS === 'web'
            ? date !== null
              ? engToBdNum(moment(date).format('YYYY-MM-DD').toString())
              : ''
            : select_date !== null
            ? engToBdNum(moment(select_date).format('YYYY-MM-DD').toString())
            : moment().format('YYYY-MM-DD'),
      };

      let formBody = [];
      for (let key in dataToSend) {
        let encodedKey = encodeURIComponent(key);
        let encodedValue = encodeURIComponent(dataToSend[key]);
        formBody.push(encodedKey + '=' + encodedValue);
      }
      formBody = formBody.join('&');

      let url = `${BASE_URL}/GetHalnagatTime`;
      let response = await axios.post(url, formBody).then(res => res.data);

      return response;
    } catch (err) {
      console.log('Error', err);
    }
  };

  const _fetchLowerCourtDataforGr = async () => {
    try {
      let params = {
        geo_district_id: district_id,
        geo_division_id: division_id,
        status: 1,
      };

      let url = `${BASE_URL}/GetGrbranchByDivisionAndDistrict`;
      let response = await axios.get(url, {params: params});
      return response.data;
    } catch (err) {
      console.log('Error:', err);
      return [];
    }
  };
  const _fetchLowerCourtDataforGrThana = async data => {
    console.log('data', data);

    try {
      let params = {
        geo_district_id: district_id,
        geo_division_id: division_id,
        gr_branch_id: data,
        status: 1,
      };

      let url = `${BASE_URL}/GetAllPoliceStation`;

      let response = await axios.get(url, {
        params: params,
      });

      return response.data;
    } catch (err) {
      console.log('Error', err);
    }
  };

  const _fetchLowerCourtData = async data => {
    try {
      let dataToSend = {
        geo_district_id: data,
        //geo_district_id:district_id,
        geo_division_id: division_id,

        // user_id: user_id,
        //  court_name_id:data
      };
      let formBody = [];
      for (let key in dataToSend) {
        let encodedKey = encodeURIComponent(key);
        let encodedValue = encodeURIComponent(dataToSend[key]);
        formBody.push(encodedKey + '=' + encodedValue);
      }
      formBody = formBody.join('&');
      //let url = `${BASE_URL}/CourtNameToLowerCourt`;  //Custom Old
      // let url = `${BASE_URL}/GetCourtNameAlldistrictToCourtNameNumber`;
      let url = `${BASE_URL}/DivisionAndDistrictToCourtName`;
      let response = await axios.post(url, formBody).then(res => res.data);

      return response;
    } catch (err) {
      console.log('Error', err);
    }
  };

  const getGrThana = async data => {
    setDairyNamelist([]);
    try {
      const dairy_T = await _fetchLowerCourtDataforGrThana(data);
      //console.log('data', data);
      console.log('dairy_name', dairy_T);

      setDairyNamelist(
        dairy_T.map(marker => ({
          ...marker,
          value: marker.gr_branch_id,
          label: marker.name_bng,
        })),
      );
    } catch (err) {
      console.log('getGrThana Error:', err);
    }
  };

  const getLowerCourtdata = data => {
    setTypeOfAaltoId(null);
    _fetchLowerCourtData(data)
      // eslint-disable-next-line no-shadow
      .then(lower_court => {
        //console.log(lower_court);
        setLowerCourt(lower_court);
        setLowerCourts(
          lower_court.map(marker => {
            marker.value = marker.id;
            marker.label = marker.office_name_bng;
            return marker;
          }),
        );
        //setalldistrict(district);
      })
      .catch(err => console.log(err));

    if ([65, 66, 67, 68, 69, 70].includes(Number(data))) {
      setCourtType(typeOfmetrocourt); // বা যেটা value দিতে চাও
    } else {
      setCourtType(typeOfAalto); // বা যেটা value দিতে চাও
    }
  };

  const _fetchdivisionData = async () => {
    try {
      let url = `${BASE_URL}/GetDivission`;
      let response = await axios.get(url).then(res => res.data);

      return response;
      //if (response.country) return response.country;
    } catch (err) {
      console.log('Error', err);
    }
  };

  const _fetchDistrictData = async data => {
    try {
      let dataToSend = {
        division_id: data,
      };
      let formBody = [];
      for (let key in dataToSend) {
        let encodedKey = encodeURIComponent(key);
        let encodedValue = encodeURIComponent(dataToSend[key]);
        formBody.push(encodedKey + '=' + encodedValue);
      }
      formBody = formBody.join('&');
      let url = `${BASE_URL}/DivisionToDistrict`;
      let response = await axios.post(url, formBody).then(res => res.data);

      return response;
      //if (response.country) return response.country;
    } catch (err) {
      console.log('Error', err);
    }
  };

  const getDstrictsdata = data => {
    _fetchDistrictData(data)
      // eslint-disable-next-line no-shadow
      .then(district => {
        // console.log(district);
        setDistrict(district);
        //setalldistrict(district);
      })
      .catch(err => console.log(err));
  };

  async function getUserId() {
    try {
      const jsonValue = await AsyncStorage.getItem('user_id');
      if (jsonValue !== null) {
        return JSON.parse(jsonValue);
      }
    } catch (err) {
      console.error(err);
    }
  }

  /*
const getLowerCourtdata = (data) => { _fetchLowerCourtData(data)
  // eslint-disable-next-line no-shadow
  .then(lower_court => {
     //console.log(lower_court);
     setLowerCourt(lower_court);
    //setalldistrict(district);
  })
  .catch(err => console.log(err)); 
}  
*/

  const _saveBasicInfo = data => {
    //console.log(data);
    //  return data;
    try {
      let url = `${BASE_URL}/CaseEntryFromCaseInfo`;
      // let response = await axios.post(url, data).then((res) => res.data);
      let formBody = [];
      for (let key in data) {
        let encodedKey = encodeURIComponent(key);
        let encodedValue = encodeURIComponent(data[key]);
        formBody.push(encodedKey + '=' + encodedValue);
      }
      formBody = formBody.join('&');

      let response = axios
        .post(url, formBody)

        .then(res => res.data);
      // console.log(response);
      return response;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }
      console.log(error.config);
    }
  };

  const handleCaseCreate = values => {
    setIsLoading(true);

    const caseData = {
      case_info_id: values,
      user_id: user_id,
    };

    console.log(caseData);
    //perform api call to update password
    _saveBasicInfo(caseData)
      .then(user => {
        //console.log(user);
        if (!user) return;
        else {
          if (user.code == 200) {
            setIsLoading(false);

            Alert.alert('New Case Entry', user.msg);
            navigation.navigate('মামলা', {screen: 'TotalCaseScreen'});
          } else {
            setIsLoading(false);
            Alert.alert('New Case Entry', user.msg);
          }
          // alert("Successfully updated");
          // fetchData();
        }
      })
      .catch(err => console.log(err));
  };

  const updateDivision = (handleChange, e) => {
    //console.log(e);
    handleChange(e);
  };
  const updateDistrict = (handleChange, e) => {
    handleChange(e);
  };
  const updateTypeOfAalto = (handleChange, e) => {
    handleChange(e);
  };
  const updateDairyName = (handleChange, e) => {
    handleChange(e);
  };

  const updateLowerCourt = (handleChange, e) => {
    handleChange(e);
  };
  const [alertVisible, setAlertVisible] = useState(false);
  const handlePress = useCallback(() => {
    setAlertVisible(true);
  }, []);

  const handleClose = useCallback(() => {
    setAlertVisible(false);
  }, []);

  const handleCaselistUpdate = (values, actions) => {
    //Show Loader
    setIsLoading(true);
    setIsSearch(false);

    _fetchCaseInfoData(values)
      // eslint-disable-next-line no-shadow
      .then(getCaseInfo => {
        setCaseInfo(getCaseInfo.fulldatas);
        setIsSearchDateBig(getCaseInfo.is_search_date_bigs);

        //Hide Loader
        // console.log(getCaseInfo);
        setIsLoading(false);
        setIsSearch(true);
      })
      .catch(err => console.log(err));

    /*
    halnagatDateTime()
    .then(halnagat => {
        setHalnagatTime(ReplaceTextFunction(halnagat[0].halnagatTime));
        setDayName(ReplaceTextDayFunction(halnagat[0].day_name));
    })
    .catch(err => console.log(err));
    */
  };

  const _causeListScrapUpdate = async data => {
    //console.log(data);
    //  return data;
    try {
      let url = `${BASE_URL}/CauseListScrapUpdate`;
      // let response = await axios.post(url, data).then((res) => res.data);
      let formBody = [];
      for (let key in data) {
        let encodedKey = encodeURIComponent(key);
        let encodedValue = encodeURIComponent(data[key]);
        formBody.push(encodedKey + '=' + encodedValue);
      }
      formBody = formBody.join('&');

      let response = await axios
        .post(url, formBody)

        .then(res => res.data);
      //alert('hi in exe back')
      console.log(response);
      return response;
    } catch (error) {}
  };

  const handleCaseDiaryFromToDate = values => {
    setIsLoading(true);
    setCaseInfo([]);

    const caseData = {
      StartDate:
        Platform.OS === 'web'
          ? date !== null
            ? moment(date).format('YYYY-MM-DD')
            : ''
          : select_date !== null
          ? moment(select_date).format('YYYY-MM-DD')
          : moment().format('YYYY-MM-DD'),
      EndDate:
        Platform.OS === 'web'
          ? date !== null
            ? moment(date).format('YYYY-MM-DD')
            : ''
          : select_date !== null
          ? moment(select_date).format('YYYY-MM-DD')
          : moment().format('YYYY-MM-DD'),
      DivissionId: division_id,
      geo_district_id: district_id,
      lower_court_id: values.lower_court_name,
    };

    console.log(caseData);
    //perform api call to update password
    _causeListScrapUpdate(caseData)
      .then(val => {
        //  setCaseInfo(val.fulldatas);
        // if(val.code==200){
        setIsLoading(false);
        //  setFinalSearchDate(val.FinalSearchDate)
        //  console.log(val.fulldatas);
        alert(val.msg);
        //  }
      })
      .catch(err => console.log(err));
  };
  // const widthArr = [80, 400, 140, 100, 100, 100];
  const calculateWidths = () => {
    const totalWidth = windowWidth - 40;

    const widths = {
      serial: totalWidth * 0.05, // 5%
      caseNo: totalWidth * 0.35, // 35%
      activity: totalWidth * 0.1, // 10%
      nextDate: totalWidth * 0.08, // 8%
      order: totalWidth * 0.15, // 15%
      action: totalWidth * 0.1, // 10%
    };

    return [
      widths.serial,
      widths.caseNo,
      widths.activity,
      widths.nextDate,
      widths.order,
      widths.action,
    ];
  };

  const widthArr = calculateWidths();
  const tableTitle = [
    'ক্রমিক নং',
    'মামলার নম্বর',
    'কার্যক্রম',
    'পরবর্তী তারিখ',
    'সংক্ষিপ্ত আদেশ',
    'পদক্ষেপ',
  ];
  const element = (item, index) => (
    <View style={styles.buttonStyleContainer}>
      <Pressable
        style={styles.buttons}
        onPress={() => {
          confirmAlert({
            title: 'মামলা যোগ করার জন্য নিশ্চিত করুন',
            message: 'আপনি এই কাজ করতে নিশ্চিত "এটা কি আপনার মামলা ??".',
            buttons: [
              {
                label: 'হ্যাঁ',
                onClick: () => handleCaseCreate(item.case_info_id),
              },
              {
                label: 'না',
                //onClick: () => alert('Click No')
              },
            ],
          });
          // Alert.alert(
          //   "মামলা যোগ করার জন্য নিশ্চিত করুন",
          //   "Alert text",
          //   item !== null
          //     ? [
          //       { text: "হ্যাঁ", onPress: () => handleCaseCreate(item)},

          //       { text: "না", }
          //     ]
          //     : null

          // );
          //handleCaseCreate(item);
          // navigation.navigate('CaseHistoryScreen', {
          //   caseType: case_type_id,
          //   case_number: item.case_number,
          //   case_year: item.case_year,
          // });
        }}
      >
        <Text style={styles.texts}>মামলা যোগকরি</Text>
      </Pressable>
    </View>
  );

  const [lowerCourtOpen, setLowerCourtOpen] = useState(false);

  return (
    <View
      style={
        Platform.OS === 'web' && windowWidth >= 600
          ? globalStyles.mainContainer
          : globalStyles.mainContainerMobile
      }
    >
      <LeftBar>
        <LeftBarItem
          selectcolor="true"
          name="দৈনিক কার্যতালিকা"
          stack="দৈনিক কার্যতালিকা"
          screen="DailyCaseListScreen"
        />
      </LeftBar>

      <View
        style={
          Platform.OS === 'web' && windowWidth >= 600
            ? globalStyles.bodyContainer
            : globalStyles.bodyContainerMobile
        }
      >
        <TouchableWithoutFeedback
          onPress={() => {
            closeDropdown();
          }}
        >
          <View>
            <View
              style={
                Platform.OS === 'web' && windowWidth >= 600
                  ? styles.headerFixed
                  : null
              }
            >
              <KeyboardAvoidingView
                style={styles.containerSearch}
                behavior="padding"
                enabled
              >
                <WavyTopBar
                  customStyles={[styles.backgroundImage, {zIndex: -1}]}
                />

                <Formik
                  enableReinitialize
                  initialValues={{
                    search_date: '',
                    division_name: '',
                    district_name: '',
                    lower_court_name: '',
                    type_of_adalot: '',
                    dairyName: '',
                  }}
                  validationSchema={registerSchema}
                  onSubmit={(values, actions) => {
                    handleCaselistUpdate(values, actions);
                  }}
                  // eslint-disable-next-line no-undef
                  // innerRef={formikElement}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                  }) => (
                    <>
                      <View style={styles.FormGroup}>
                        {/* <InputLevel>Division Name</InputLevel> */}

                        <View style={styles.pickerWrapper}>
                          <Picker
                            selectedValue={division_id ? division_id : 0}
                            style={
                              isPlaceholder(division_id)
                                ? styles.pickerP2
                                : styles.picker2
                            }
                            // onValueChange={(itemValue, itemIndex) => setdivision_id(itemValue)}
                            onValueChange={(itemValue, itemIndex) => {
                              // filterdistrictResults(itemValue);

                              setdivisionId(itemValue);
                              getDstrictsdata(itemValue);
                              updateDivision(
                                handleChange('division_name'),
                                itemValue,
                              );
                            }}
                            mode="dropdown"
                          >
                            <Picker.Item label="বিভাগ" value="0" color="red" />

                            {division?.map((item, index) => {
                              return (
                                <Picker.Item
                                  color="#333"
                                  label={item.division_name_bng.toString()}
                                  value={item.geo_division_id.toString()}
                                  key={index}
                                />
                              );
                            })}
                          </Picker>
                          {touched.division_name && errors.division_name ? (
                            <ErrorText>{errors.division_name}</ErrorText>
                          ) : null}
                        </View>
                      </View>
                      <View style={styles.FormGroup}>
                        {/* <InputLevel>District Name</InputLevel> */}
                        <View style={styles.pickerWrapper}>
                          <Picker
                            selectedValue={district_id ? district_id : 0}
                            style={
                              isPlaceholder(district_id)
                                ? styles.pickerP2
                                : styles.picker2
                            }
                            onValueChange={(itemValue, itemIndex) => {
                              setDistrictId(itemValue);

                              getLowerCourtdata(itemValue);
                              setDistrictName(
                                district[itemIndex - 1]?.district_name_bng,
                              );
                              updateDistrict(
                                handleChange('district_name'),
                                itemValue,
                              );
                              //getCourtData(itemValue);
                            }}
                            mode="dropdown"
                          >
                            <Picker.Item label="জেলা" value="0" color="red" />
                            {district.map((item, index) => {
                              return (
                                <Picker.Item
                                  color="#333"
                                  label={item.district_name_bng.toString()}
                                  value={item.geo_district_id.toString()}
                                  key={index}
                                />
                              );
                            })}
                          </Picker>
                          {touched.district_name && errors.district_name ? (
                            <ErrorText>{errors.district_name}</ErrorText>
                          ) : null}
                        </View>
                      </View>

                      <View style={[styles.FormGroup]}>
                        <View style={[styles.pickerWrapper]}>
                          <Picker
                            selectedValue={
                              typeOfAalto_id ? typeOfAalto_id : '0'
                            }
                            style={[
                              isPlaceholder(typeOfAalto_id)
                                ? styles.pickerP2
                                : styles.picker2,
                              {width: 150},
                            ]}
                            dropdownIconColor="#1e3a8a"
                            onValueChange={(itemValue, itemIndex) => {
                              const selectedItem = courtType.find(
                                item => item.id === itemValue,
                              );
                              if (selectedItem) {
                                const filteredData = filterCourtsByOriginId(
                                  lower_court,
                                  selectedItem.id,
                                  selectedItem.office_origin_ids,
                                );
                                //  console.log(filteredData);
                                // setCourtType(typeOfAalto);
                              }
                              setTypeOfAaltoId(itemValue);
                              updateTypeOfAalto(
                                handleChange('name'),
                                itemValue,
                              );
                            }}
                            mode="dropdown"
                          >
                            <Picker.Item
                              label="আদালতের ধরন"
                              value="0"
                              color="red"
                            />

                            {courtType.map((item, index) => (
                              <Picker.Item
                                key={index}
                                label={`- ${item.name}`}
                                value={item.id.toString()}
                                color="#333"
                              />
                            ))}
                          </Picker>

                          {touched.type_of_adalot && errors.type_of_adalot ? (
                            <ErrorText>{errors.type_of_adalot}</ErrorText>
                          ) : null}
                        </View>
                      </View>

                      <View style={styles.FormGroup}>
                        <View style={[styles.pickerWrapper]}>
                          <View
                            style={{
                              flexDirection: 'row',
                              height: windowWidth >= 600 ? 27 : 40,
                              zIndex: 100,
                            }}
                          >
                            <DropDownFormik
                              zIndex={9999999}
                              zIndexInverse={9999987}
                              listMode={
                                Platform.OS === 'web' && windowWidth >= 600
                                  ? 'FLATLIST'
                                  : 'MODAL'
                              }
                              modalContentContainerStyle={{
                                // minHeight:responsiveHeight(50),
                                height: 500,
                              }}
                              style={{
                                width: 200,
                                height: windowWidth >= 600 ? 27 : 100,
                              }}
                              open={lowerCourtOpen}
                              dropDownDirection="BOTTOM"
                              setOpen={setLowerCourtOpen}
                              searchable={false}
                              name="lower_court_name"
                              placeholder="আদালত নির্বাচন করুন"
                              items={lower_courts}
                              onChangeValue={value => {
                                getGrThana(value);
                                // এখানে তোমার কাজ
                                // getGrThana(value)
                              }}
                              dropDownContainerStyle={{
                                minHeight: 550,
                                lineHeight: 15,
                              }}
                            />
                          </View>
                          {touched.lower_court_name &&
                          errors.lower_court_name ? (
                            <ErrorText>{errors.lower_court_name}</ErrorText>
                          ) : null}
                          {/* </Popable> */}
                        </View>
                      </View>
                      {typeOfAalto_id == 1 && (
                        <View style={styles.FormGroup}>
                          <View style={styles.pickerWrapper}>
                            <Picker
                              selectedValue={dairyName_id ? dairyName_id : '0'}
                              style={
                                isPlaceholder(dairyName_id)
                                  ? styles.pickerP2
                                  : styles.picker2
                              }
                              dropdownIconColor="#1e3a8a"
                              onValueChange={(itemValue, itemIndex) => {
                                setDairyNameId(itemValue);

                                // if (itemIndex > 0) {
                                //   setDairyName(dairyNames[itemIndex - 1]?.name);
                                // }

                                updateDairyName(
                                  handleChange('dairyName'),
                                  itemValue,
                                );
                              }}
                              mode="dropdown"
                            >
                              <Picker.Item
                                label="থানা/অঞ্চল নির্বাচন করুন"
                                value="0"
                                color="#1d4ed8"
                              />

                              {dairyNamelist.map((item, index) => (
                                <Picker.Item
                                  key={index}
                                  label={`- ${item.label}`}
                                  value={item.value.toString()}
                                  color="#333"
                                />
                              ))}
                            </Picker>

                            {touched.dairyName && errors.dairyName ? (
                              <ErrorText>{errors.dairyName}</ErrorText>
                            ) : null}
                          </View>
                        </View>
                      )}

                      <View style={styles.FormGroup}>
                        {/* <InputLevel>তারিখ :</InputLevel> */}
                        <>
                          <View style={{flexDirection: 'row'}}>
                            {Platform.OS === 'web' ? (
                              <TouchableOpacity
                                onPress={() => setVisible(true)}
                                style={styles.sectionStyle}
                              >
                                <TextInput
                                  style={styles.inputs1}
                                  value={
                                    Platform.OS === 'web'
                                      ? date !== null
                                        ? engToBdNum(
                                            moment(date)
                                              .format('DD-MM-YYYY')
                                              .toString(),
                                          )
                                        : ''
                                      : select_date !== null
                                      ? engToBdNum(
                                          moment(select_date)
                                            .format('DD-MM-YYYY')
                                            .toString(),
                                        )
                                      : ''
                                  }
                                  onChangeText={handleChange('search_date')}
                                  onBlur={handleBlur('search_date')}
                                  placeholder={'DD-MM-YYYY'}
                                  underlineColorAndroid="transparent"
                                  // isEditing={isEditing}
                                  onTouchStart={showDatePicker}
                                />
                                <Image
                                  source={{
                                    uri: 'https://bdjudgecourt.com/assets/calendar.png',
                                  }}
                                  style={styles.imageStyle}
                                />
                              </TouchableOpacity>
                            ) : (
                              <TextInput
                                style={styles.inputs1}
                                value={
                                  select_date !== null
                                    ? engToBdNum(
                                        moment(select_date)
                                          .format('DD-MM-YYYY')
                                          .toString(),
                                      )
                                    : engToBdNum(
                                        moment()
                                          .format('DD-MM-YYYY')
                                          .toString(),
                                      )
                                }
                                onChangeText={handleChange('search_date')}
                                onBlur={handleBlur('search_date')}
                                placeholder={'DD-MM-YYYY'}
                                underlineColorAndroid="transparent"
                                // isEditing={isEditing}
                                onTouchStart={showDatePicker}
                              />
                            )}
                            {/* { Platform.OS === 'web' ? (  <FontAwesome.Button     name='calendar'   color='#f00'  style={{ width:30, zIndex:999999, height:25, marginLeft:,marginTop:3 }}  onPress={() =>setVisible(true)}></FontAwesome.Button> ):null } */}
                          </View>
                          {Platform.OS === 'web' ? (
                            <View
                              style={{
                                justifyContent: 'center',
                                flex: 1,
                                alignItems: 'center',
                              }}
                            >
                              {/* <Button onPress={() => setVisible(true)} uppercase={false} mode="outlined">  Pick time </Button> */}

                              <DatePickerModal
                                locale={locale}
                                mode="single"
                                visible={visible}
                                onDismiss={onDismiss}
                                date={date}
                                onConfirm={onChangeSingle}
                                onChange={onChangeSingle}
                                validRange={{
                                  startDate: pastDate,
                                  disabledDates: [futureDate],
                                  // startDate: new Date(2021, 1, 2), // optional
                                  // endDate: new Date(), // optional
                                }}
                                style={{width: 300, height: 400}}
                                presentationStyle="formSheet"
                                // saveLabel="Save" // optional
                                // uppercase={false} // optional, default is true
                                // label="Select date" // optional
                                // animationType="slide" // optional, default is 'slide' on ios/android and 'none' on web
                                // startYear={2000} // optional, default is 1800
                                // endYear={2100} // optional, default is 2200
                                //allowEditing={true} // optional, default is true
                                //inputEnabled={true} // optional, default is true
                              />
                            </View>
                          ) : (
                            <DateTimePickerModal
                              isVisible={isDatePickerVisible}
                              mode="date"
                              date={select_date ? select_date : new Date()}
                              onConfirm={handleConfirm}
                              onCancel={hideDatePicker}
                              // minimumDate={new Date()}
                              // minimumDate={("YYYY, MM, DD")}
                              // maximumDate={moment().add(30, 'days').format("DD-MM-YYYY")}
                            />
                          )}
                        </>
                        {touched.search_date && errors.search_date ? (
                          <ErrorText>{errors.search_date}</ErrorText>
                        ) : null}
                      </View>

                      {/* { isLoading === true ? (

                  ):(

                    )}

                     */}
                      <View style={{flexDirection: 'row', marginTop: 10}}>
                        <View style={styles.Topview}>
                          <AppBtn
                            title="অনুসন্ধান "
                            onPress={handleSubmit}
                            width={80}
                            fontwidth="bold"
                            disabled={isLoading ? true : false}
                          />
                        </View>

                        <View style={styles.halnagadbtn}>
                          <AppBtn
                            title="হালনাগাদ"
                            //  onPress={handleCaseDiaryFromToDate(values)}
                            onPress={() => handleCaseDiaryFromToDate(values)}
                            BGcolor="#102020"
                            width={80}
                            disabled={isLoading ? true : false}
                          />
                        </View>
                      </View>
                    </>
                  )}
                </Formik>
              </KeyboardAvoidingView>

              {isLoading ? (
                <View style={{height: 550, paddingVertical: 100}}>
                  <ActivityIndicator size="large" />
                </View>
              ) : (
                <View style={styles.wrapper}>
                  <View style={styles.tabWrapper}>
                    <TouchableOpacity
                      activeOpacity={0.9}
                      style={[
                        styles.tabButton,
                        activeTab === 'images' && styles.activeTabButton,
                      ]}
                      onPress={() => setActiveTab('images')}
                    >
                      <Text
                        style={[
                          styles.tabText,
                          activeTab === 'images' && styles.activeTabText,
                        ]}
                      >
                        ছবি
                      </Text>
                    </TouchableOpacity>

                    <TouchableOpacity
                      activeOpacity={0.9}
                      style={[
                        styles.tabButton,
                        activeTab === 'files' && styles.activeTabButton,
                      ]}
                      onPress={() => setActiveTab('files')}
                    >
                      <Text
                        style={[
                          styles.tabText,
                          activeTab === 'files' && styles.activeTabText,
                        ]}
                      >
                        কার্যতালিকা
                      </Text>
                    </TouchableOpacity>
                  </View>

                  <View style={styles.contentBox}>
                    {activeTab === 'images' ? (
                      <>
                        {grAllData.length == 0 &&
                        isSearch &&
                        isLoading == false ? (
                          <Text
                            style={[
                              styles.Topheader,
                              {
                                marginTop:
                                  windowHeight - windowHeight / 2 - 100,
                              },
                            ]}
                          >
                            {/* কোন মামলা পাওয়া যায়নি। */} এই পেইজ এখনো আপডেট
                            কারা হয়নি
                          </Text>
                        ) : (
                          <>
                            <View style={{zIndex: -1, marginTop: -40}}>
                              {/* <Text style={styles.Topheader}>
                                {caseInfo?.length > 0
                                  ? caseInfo[0]?.office_name_bng + ','
                                  : ''}{' '}
                                {caseInfo?.length > 0
                                  ? caseInfo[0]?.district_name_bng
                                  : ''}
                              </Text> */}
                              <Text style={styles.Topheader}>
                                কার্যতালিকার ছবি সমূহ
                              </Text>
                              <View>
                                {!isLoading && Platform.OS === 'web' ? (
                                  <>
                                    <Text style={styles.TopheaderDate}>
                                      তারিখঃ{' '}
                                      {date !== null
                                        ? ReplaceTextFunction(
                                            moment(date).format('DD-MM-YYYY'),
                                          )
                                        : ''}
                                      ,{' '}
                                      {date !== null
                                        ? ReplaceTextDayFunction(
                                            moment(date).format('dddd'),
                                          )
                                        : ''}{' '}
                                      (সর্বশেষ হালনাগাদঃ{' '}
                                      {caseInfo?.length > 0
                                        ? ReplaceTextFunction(
                                            caseInfo[0]?.halnagatTime,
                                          )
                                        : ''}
                                      )
                                    </Text>
                                    {/* <Text
                                  style={[styles.Topheader, {marginTop: -2}]}
                                >
                                  সর্বমোট মামলা:{' '}
                                  {caseInfo.length
                                    ? engToBdNum(caseInfo.length.toString())
                                    : engToBdNum('0')}
                                </Text> */}
                                  </>
                                ) : null}
                              </View>
                            </View>
                            <FlatList
                              data={groupImagesIntoRows(grAllData)}
                              keyExtractor={(item, index) => index.toString()}
                              renderItem={renderImageRow}
                              showsVerticalScrollIndicator={true}
                              scrollEnabled={true}
                              ListEmptyComponent={
                                <View style={styles.emptyContainer}>
                                  <Text style={styles.emptyText}>
                                    No data found
                                  </Text>
                                </View>
                              }
                            />
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        <View style={{zIndex: -1, marginTop: -40}}>
                          <Text style={styles.Topheader}>
                            {caseInfo?.length > 0
                              ? caseInfo[0]?.office_name_bng + ','
                              : ''}{' '}
                            {caseInfo?.length > 0
                              ? caseInfo[0]?.district_name_bng
                              : ''}
                          </Text>
                          <Text style={styles.Topheader}>
                            দৈনিক কার্যতালিকা
                          </Text>
                          <View>
                            {!isLoading && Platform.OS === 'web' ? (
                              <>
                                <Text style={styles.TopheaderDate}>
                                  তারিখঃ{' '}
                                  {date !== null
                                    ? ReplaceTextFunction(
                                        moment(date).format('DD-MM-YYYY'),
                                      )
                                    : ''}
                                  ,{' '}
                                  {date !== null
                                    ? ReplaceTextDayFunction(
                                        moment(date).format('dddd'),
                                      )
                                    : ''}{' '}
                                  (সর্বশেষ হালনাগাদঃ{' '}
                                  {caseInfo?.length > 0
                                    ? ReplaceTextFunction(
                                        caseInfo[0]?.halnagatTime,
                                      )
                                    : ''}
                                  )
                                </Text>
                                {/* <Text
                                  style={[styles.Topheader, {marginTop: -2}]}
                                >
                                  সর্বমোট মামলা:{' '}
                                  {caseInfo.length
                                    ? engToBdNum(caseInfo.length.toString())
                                    : engToBdNum('0')}
                                </Text> */}
                              </>
                            ) : null}
                          </View>
                        </View>
                        {Platform.OS === 'web' && windowWidth >= 600 ? (
                          <View style={[styles.webView, {marginTop: 5}]}>
                            <Table
                              borderStyle={{
                                borderWidth: 0.3,
                                borderColor: '#dfdddd',
                              }}
                            >
                              <Row
                                data={tableTitle}
                                widthArr={widthArr}
                                style={styles.head}
                                textStyle={[styles.text1]}
                              />
                            </Table>
                            <View style={{height: 330}}>
                              <ScrollView
                                // onScroll={e => onScroll(e)}
                                style={[styles.dataWrapper, {marginBottom: 30}]}
                              >
                                <Table
                                  borderStyle={{
                                    borderWidth: 0.3,
                                    borderColor: '#dfdddd',
                                    paddingBottom: 100,
                                  }}
                                >
                                  {caseInfo.map((item, index) => (
                                    <TableWrapper
                                      key={index}
                                      style={[
                                        styles.row,
                                        {
                                          paddingVertical: 0,
                                          backgroundColor:
                                            index % 2 ? '#F7F6E7' : '#fff',
                                        },
                                      ]}
                                    >
                                      <Cell
                                        key={1}
                                        width={widthArr[0]}
                                        data={
                                          isSearchDateBig == 1
                                            ? engToBdNum((index + 1).toString())
                                            : engToBdNum(
                                                item.serial_no.toString(),
                                              )
                                        }
                                        textStyle={styles.text}
                                      />
                                      <Cell
                                        key={2}
                                        width={widthArr[1]}
                                        data={
                                          item.type_name +
                                          ' - ' +
                                          engToBdNum(
                                            item.case_number.toString(),
                                          ) +
                                          item.arising_out_of +
                                          '/' +
                                          engToBdNum(
                                            item.case_year.toString(),
                                          ) +
                                          ' ' +
                                          item.upazila_name_bng
                                        }
                                        textStyle={styles.text}
                                      />
                                      <Cell
                                        key={3}
                                        width={widthArr[2]}
                                        data={
                                          isSearchDateBig == 1
                                            ? item.result
                                            : item.activities
                                        }
                                        textStyle={styles.text}
                                      />
                                      <Cell
                                        key={4}
                                        width={widthArr[3]}
                                        data={
                                          isSearchDateBig == 1
                                            ? ''
                                            : item.next_date == '01-01-1970'
                                            ? ''
                                            : engToBdNum(
                                                item.next_date.toString(),
                                              )
                                        }
                                        textStyle={styles.text}
                                      />
                                      <Cell
                                        key={5}
                                        width={widthArr[4]}
                                        data={
                                          isSearchDateBig == 1
                                            ? ''
                                            : item.result
                                        }
                                        textStyle={styles.text}
                                      />
                                      <Cell
                                        key={6}
                                        width={widthArr[5]}
                                        data={element(item, index)}
                                      />
                                    </TableWrapper>
                                  ))}
                                </Table>

                                {Platform.OS === 'web' ? (
                                  caseInfo?.length == 0 &&
                                  isSearch &&
                                  isLoading == false ? (
                                    <Text
                                      style={[
                                        styles.Topheader,
                                        {
                                          marginTop:
                                            windowHeight -
                                            windowHeight / 2 -
                                            100,
                                        },
                                      ]}
                                    >
                                      {/* কোন মামলা পাওয়া যায়নি। */} এই পেইজ
                                      এখনো আপডেট কারা হয়নি
                                    </Text>
                                  ) : null
                                ) : caseInfo == 'undefined' &&
                                  isSearch &&
                                  isLoading == false ? (
                                  <Text style={styles.Topheader}>
                                    কোন মামলা পাওয়া যায়নি।
                                  </Text>
                                ) : null}
                              </ScrollView>
                            </View>
                          </View>
                        ) : null}
                      </>
                    )}
                  </View>
                </View>
              )}
            </View>

            <View></View>
          </View>
        </TouchableWithoutFeedback>
      </View>

      <Modal
        visible={imageModalVisible}
        transparent={true}
        animationType="fade"
        // onRequestClose={() => setImageModalVisible(false)}
      >
        <View style={styles.modalContainer}>
          {/* Close button */}
          <Pressable
            style={styles.closeButton}
            onPress={() => setImageModalVisible(false)}
          >
            <Text style={styles.closeText}>✕</Text>
          </Pressable>

          {/* <Text>{ JSON.stringify(grSingleData)}</Text> */}
          {/* Large Image */}
          <TouchableOpacity activeOpacity={1} style={styles.fullImageWrapper}>
            {grSingleData && grSingleData.file_path && (
              <Image
                style={styles.fullImage}
                source={{
                  uri: 'https://api.bdjudgecourt.com' + grSingleData.file_path,
                }}
              />
            )}
          </TouchableOpacity>
        </View>
      </Modal>
    </View>
  );
}

const styles = StyleSheet.create({
  text: {textAlign: 'center', fontSize: 14, fontFamily: 'SolaimanLipi'},
  text1: {
    textAlign: 'center',
    fontSize: 14,
    fontFamily: 'SolaimanLipi',
    fontWeight: 'bold',
  },
  row: {flexDirection: 'row'},
  dataWrapper: {marginTop: -1, marginRight: -25},
  table: {
    width: '100%',
    display: 'table',
    borderSpacing: 0,
    borderCollapse: 'separate',
  },
  th: {
    top: 0,
    left: 0,
    zIndex: 2,
    position: 'sticky',
    backgroundColor: '#fff',
  },

  sectionStyle: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: '#ccc',
    height: windowWidth >= 600 ? 27 : 41,
    borderRadius: 5,
    margin: 10,
    zIndex: -1,
  },
  imageStyle: {
    padding: 10,
    margin: 5,
    height: 25,
    width: 25,
    resizeMode: 'stretch',
    alignItems: 'center',
  },
  webView: {
    flex: 1,
    // marginRight: 'auto',
    //  marginLeft: 'auto',
    width: tableWidth,
    // paddingTop: 10,
    paddingBottom: 10,
    paddingHorizontal: 0,
    //  backgroundColor: '#fff',
    //  borderRadius: 8,
    marginBottom: 10,
  },

  head: {
    height: 30,
    backgroundColor: 'khaki',
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
  },
  body: {
    height: '200',
  },

  headerFixed: {
    top: 0,
    left: 0,
    zIndex: 2,
    position: 'sticky',
    backgroundColor: '#fff',
    // paddingBottom:10,
  },

  headTextsl: {
    fontSize: 14,
    // fontWeight: 'bold',
    textAlign: 'center',
    color: '#000',
    justifyContent: 'center',
    width: 66,

    top: 163,
    left: 0,
    position: 'sticky',
    backgroundColor: 'khaki',
    zIndex: 2,
  },
  headText: {
    fontSize: 14,
    // fontWeight: 'bold',
    textAlign: 'center',
    color: '#000',
    justifyContent: 'center',

    top: 163,
    left: 0,
    position: 'sticky',
    backgroundColor: 'khaki',
    zIndex: 2,
  },

  buttonsMobile: {
    //flex: 1,
    // flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 5,
    paddingHorizontal: 10,
    borderRadius: 4,
    elevation: 3,
    backgroundColor: '#d1c408',
    marginTop: 0,
    // paddingTop:10,
    marginRight: 5,
    // left:130,
    top: 0,
  },
  buttons: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 3,
    paddingHorizontal: 5,
    borderRadius: 4,
    elevation: 3,
    //backgroundColor: 'green',
    marginBottom: 4,
    marginRight: 5,
  },
  texts: {
    fontSize: 14,
    // lineHeight: 14,
    fontWeight: 'bold',
    letterSpacing: 0.25,
    color: '#00f',
    fontFamily: 'SolaimanLipi',
  },

  textsMobile: {
    fontSize: 16,
    //lineHeight: 19,
    fontWeight: 'bold',
    letterSpacing: 0.25,
    color: '#000',
  },

  buttonStyleContainer: {
    flex: 1,
    flexDirection: 'row',
    marginHorizontal: 20,
    marginTop: 5,
    marginRight: 5,
  },
  buttonStyleMobileContainer: {
    marginHorizontal: 20,
    marginTop: 5,
    marginRight: 5,
  },
  rowSection: {
    height: windowWidth >= 600 ? 27 : 40,
    backgroundColor: '#f7f7f7',
  },

  rowText: {
    margin: 6,
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center',
    justifyContent: 'center',
    borderRightWidth: 1,
    borderRightColor: '#ccc',
  },
  rowTextsl: {
    margin: 6,
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center',
    justifyContent: 'center',
    borderRightWidth: 1,
    borderRightColor: '#ccc',
    width: 50,
  },

  mobileView: {
    flex: 1,
    marginRight: 'auto',
    marginLeft: 'auto',
  },

  bodyTextsl: {
    fontSize: 12,
    // fontWeight: 'bold',
    textAlign: 'center',
    color: '#000',
    justifyContent: 'center',
    width: 62,
    backgroundColor: '#ccc',
  },
  bodyTextsl1: {
    fontSize: 12,
    // fontWeight: 'bold',
    textAlign: 'center',
    color: '#000',
    justifyContent: 'center',
    width: 62,
    backgroundColor: '#fffffc',
  },
  bodyText: {
    fontSize: 14,
    // fontWeight: 'bold',
    textAlign: 'center',
    color: '#000',
    justifyContent: 'center',
    backgroundColor: '#ccc',
  },
  bodyText1: {
    fontSize: 14,
    // fontWeight: 'bold',
    textAlign: 'center',
    color: '#000',
    justifyContent: 'center',
    backgroundColor: '#fffffc',
  },

  HeadStyle: {
    height: 50,
    alignContent: 'center',
    backgroundColor: '#ffe0f0',
  },
  TableText: {
    margin: 10,
  },
  mainContainer: {
    flex: 1,
    flexDirection: 'row',
  },
  LeftContainer: {
    flex: 1,
    backgroundColor: '#aa88aa',
  },
  bodyContainer: {
    flex: 6,
  },
  viewContent: {
    flex: 1,
    padding: 8,
  },
  picker2: {
    height: windowWidth >= 600 ? 27 : 40,
    color: '#333',
    width: Platform.OS === 'web' && windowWidth >= 600 ? 100 : 150,
    backgroundColor: '#fff',
    fontFamily: 'SolaimanLipi',
  },
  pickerP2: {
    height: windowWidth >= 600 ? 27 : 40,
    color: '#989898',
    width: Platform.OS === 'web' && windowWidth >= 600 ? 100 : 150,
    backgroundColor: '#fff',
    fontFamily: 'SolaimanLipi',
  },
  inputs: {
    borderColor: '#ccc',
    borderWidth: 1,
    padding: 12,
    borderRadius: 2,
    fontSize: 13,
    backgroundColor: '#fff',
    width: Platform.OS === 'web' && windowWidth >= 600 ? 100 : 150,
    fontFamily: 'SolaimanLipi',
  },
  inputs1: {
    //borderColor: '#ccc',
    // borderWidth: 1,
    zIndex: -1,
    height: windowWidth >= 600 ? 27 : 40,
    padding: 5,
    borderRadius: 2,
    fontSize: 13,
    width: Platform.OS === 'web' && windowWidth >= 600 ? 90 : 250,
    backgroundColor: '#fff',
    fontFamily: 'SolaimanLipi',
  },
  inputs11: {
    //borderColor: '#ccc',
    // borderWidth: 1,
    padding: 5,
    borderRadius: 2,
    fontSize: 13,
    width: Platform.OS === 'web' && windowWidth >= 600 ? 110 : 250,
    backgroundColor: '#fff',
    fontFamily: 'SolaimanLipi',
  },
  FormGroup: {
    paddingHorizontal: 5,
    marginBottom: Platform.OS === 'web' && windowWidth >= 600 ? -2 : 10,
  },
  MCart: {flexDirection: 'row', padding: 0},
  borderStyles: {
    borderWidth: 1,
    borderColor: '#C1C0B9',
    // width: '100%',
  },
  Topview: {
    marginTop: Platform.OS === 'web' && windowWidth >= 600 ? -7 : 10,
    // marginBottom: 80,
    // paddingHorizontal: 10,
    marginLeft: Platform.OS === 'web' && windowWidth >= 600 ? 0 : 35,
  },
  halnagadbtn: {
    marginTop: Platform.OS === 'web' && windowWidth >= 600 ? -7 : 10,
    // marginBottom: 80,
    // paddingHorizontal: 10,
    marginLeft: Platform.OS === 'web' && windowWidth >= 600 ? 10 : 15,
  },
  pickerWrapper: {
    borderColor: '#ccc',
    borderWidth: 1,
    borderRadius: 4,
    backgroundColor: 'transparent',
  },
  picker: {
    height: 25,
    color: '#333',
    width: Platform.OS === 'web' && windowWidth >= 600 ? 200 : 250,
    backgroundColor: '#fff',
    fontFamily: 'SolaimanLipi',
  },
  containerSearch: {
    //flex: 1,
    flexDirection:
      Platform.OS === 'web' && windowWidth >= 600 ? 'row' : 'column',
    justifyContent: 'center',
    //paddingTop: .stConstantsatusBarHeight,
    // backgroundColor: '#fff',
    backgroundColor: 'transparent',
    alignItems: 'center',
    //padding: 8 ,
    //paddingTop:30,
    paddingVertical: 0,
  },
  Buttons: {
    width: 200,
    padding: 5,
    marginLeft: 10,
  },
  input: {
    width: 200,
    fontSize: 20,
    padding: 5,
    paddingLeft: 20,
    marginBottom: 10,
    marginRight: 10,
    color: 'white',
    borderWidth: 0.5,
    borderColor: 'green',
    borderRadius: 8,
  },
  tagContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  tag: {
    marginRight: 8,
    marginBottom: 8,
  },
  backgroundImage: {
    flex: 1,
    // width: '100%',
    height: 'auto',
    //height: 120,
    position: 'absolute',
    width: Dimensions.get('window').width - 190,
    bottom: 0,
    zIndex: -1,
  },
  Topcontainer: {
    flex: 1,
    padding: 16,
    //paddingTop: 30,
    width: '99%',
    backgroundColor: '#fff',
    alignItems: 'center',
  },
  TotalCaseFound: {
    fontSize: 14,
    textAlign: 'center',
    fontWeight: 'bold',
    width: responsiveWidth(100),
  },
  asperSupremeCourt: {
    fontSize: 10,
    textAlign: 'center',
    fontWeight: 'bold',
    width: responsiveWidth(100),
  },
  hddata: {
    padding: 5,
    borderWidth: 1,
    borderColor: 'black',
    borderRadius: 6,
    marginTop: 5,
    marginBottom: 0,
    backgroundColor: '#C1EfFf',
    width: responsiveWidth(96),
  },
  textDescription: {
    paddingTop: 3,
    fontSize: 13,
    width: responsiveWidth(60),
  },
  textTile: {
    fontSize: 14,
    alignItems: 'center',
    justifyContent: 'center',
    width: responsiveWidth(28),
  },
  textTilecln: {
    fontSize: 16,
    alignItems: 'center',
    justifyContent: 'center',
    width: 8,
  },
  main_body: {
    padding: 5,
    borderWidth: 1,
    borderColor: 'black',
    borderRadius: 6,
    marginBottom: 0,
    backgroundColor: '#FFF',
    width: responsiveWidth(97),
  },
  container: {
    flex: 1,
    padding: 2,
    paddingTop: 30,
    width: '99%',
    backgroundColor: '#fff',
    alignItems: 'center',
  },
  Topheader: {
    textAlign: 'center',
    //fontWeight: '',
    fontSize: 20,
    color: '#000',
    fontFamily: 'SolaimanLipi',
    // marginTop: 2,
  },
  TopheaderDate: {
    textAlign: 'center',
    //fontWeight: 'bold',
    fontSize: 16,
    color: '#000',
    fontFamily: 'SolaimanLipi',
  },
  TopheaderDate2: {
    textAlign: 'center',
    //fontWeight: 'bold',
    fontSize: 16,
    color: '#000',
  },

  // header: {height: 50, backgroundColor: '#537791'},
  // texts: {textAlign: 'center', fontWeight: '100'},
  // dataWrapper: {marginTop: -1, width: '99%'},
  // row: {height: 40, backgroundColor: '#E7E6E1'},

  tabStyle: {},
  scrollStyle: {
    backgroundColor: 'white',
    paddingLeft: 65,
    paddingRight: 65,
    // justifyContent: 'center',
  },
  tabBarTextStyle: {
    fontSize: 14,
    fontWeight: 'normal',
  },
  underlineStyle: {
    height: 3,
    backgroundColor: 'red',
    borderRadius: 3,
    width: 15,
  },
  hddata: {
    padding: 5,
    borderWidth: 1,
    borderColor: 'black',
    borderRadius: 6,
    marginTop: 5,
    marginBottom: 0,
    backgroundColor: '#C1EfFf',
    width: responsiveWidth(96),
  },
  textTile: {
    fontSize: 14,
    alignItems: 'center',
    justifyContent: 'center',
    width: responsiveWidth(29),
  },
  textTilecln: {
    fontSize: 16,
    alignItems: 'center',
    justifyContent: 'center',
    width: 8,
  },

  textDescription: {
    paddingTop: 3,
    fontSize: 13,
    width: responsiveWidth(60),
  },

  /// --------------add tab styles ----------------------

  wrapper: {
    marginTop: 20,
    marginHorizontal: 16,
    zIndex: -1,
  },

  tabWrapper: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    // borderBottomWidth: 2,
    // borderBottomColor: '#dbeafe',
    paddingBottom: 0,
  },

  tabButton: {
    paddingVertical: 7,
    paddingHorizontal: 20,
    marginRight: 10,
    borderRadius: 12,
    // borderTopLeftRadius: 12,
    // borderTopRightRadius: 12,
    backgroundColor: '#e2e8f0',
    borderWidth: 1,
    borderColor: '#cbd5e1',
    cursor: 'pointer',
    // borderBottomWidth: 0,
  },

  activeTabButton: {
    backgroundColor: '#ffffff',
    borderColor: '#60a5fa',
    shadowColor: '#3b82f6',
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.18,
    shadowRadius: 10,
    elevation: 8,
  },

  tabText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#475569',
    fontFamily: 'SolaimanLipi',
  },

  activeTabText: {
    color: '#2563eb',
    fontWeight: '600',
    fontFamily: 'SolaimanLipi',
  },

  contentBox: {
    backgroundColor: '#ffffff',
    borderBottomLeftRadius: 24,
    borderBottomRightRadius: 24,
    borderTopRightRadius: 24,
    padding: 24,
    paddingTop: 0,
    height: windowHeight - 100,
  },

  contentText: {
    fontSize: 16,
    color: '#334155',
    fontWeight: '500',
  },

  // ----- image large in modal -------
  cardWrapper: {
    width: '33%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  smallImage: {
    width: 300,
    height: 300,
    resizeMode: 'contain',
    borderRadius: 12,
  },
  dateText: {
    fontSize: 16,
    marginTop: 20,
    color: '#555',
    textAlign: 'center',
    lineHeight: 24,
    fontWeight: '500',
  },
  modalContainer: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.95)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  fullImageWrapper: {
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  fullImage: {
    width: '99%',
    height: '90%',
    resizeMode: 'contain',
  },
  closeButton: {
    position: 'absolute',
    top: 50,
    right: 25,
    zIndex: 10,
    backgroundColor: 'rgba(255,255,255,0.15)',
    width: 42,
    height: 42,
    borderRadius: 21,
    justifyContent: 'center',
    alignItems: 'center',
  },
  closeText: {
    color: '#fff',
    fontSize: 22,
    fontWeight: 'bold',
  },

  imageRowItem: {
    width: '31.33%',
    aspectRatio: 1,
    backgroundColor: '#f5f5f5',
    borderRadius: 8,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: '#e0e0e0',
    position: 'relative',
  },
  imageRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 12,
    paddingHorizontal: 4,
    gap: 8,
  },

  emptyContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 50,
  },
  emptyText: {
    fontSize: 16,
    color: '#999',
    fontWeight: '500',
  },
});
